import React from 'react';
import { useSelector } from 'react-redux';
import { Card, CardContent } from "../../ui/card";
import { Loader, Wifi, Upload, Download, Clock, Activity, NetworkIcon, CalendarClock } from "lucide-react";

const NetworkStats = () => {
  const { lastActivity, lastActivityIsLoading } = useSelector(state => state.UserStatus);

  const getLocation = () => {
    if (lastActivity?.city && lastActivity?.country) {
      return `${lastActivity.city}, ${lastActivity.country}`;
    }

    return 'Unknown';
  }

  return (
    <Card>
      <CardContent className="pt-6">
        <div className="flex items-center gap-2 mb-4">
          {lastActivityIsLoading && (<Loader className="h-5 w-5 text-blue-500 animate-spin" />)}
          {!lastActivityIsLoading && (<Wifi className="h-5 w-5 text-blue-500" />)}
          <h3 className="text-lg font-semibold">
            Network Stats
          </h3>
        </div>

        <p className="text-sm text-gray-500 mb-4">
          Real-time network performance metrics and connection details
        </p>

        <div className="space-y-4">
          <div className="flex justify-between items-center p-3 bg-gray-50 rounded-lg">
            <span className="text-sm font-medium">IP Address</span>
            <span className="text-sm">{lastActivity?.ip}</span>
          </div>

          <div className="flex justify-between items-center p-3 bg-gray-50 rounded-lg">
            <span className="text-sm font-medium">Internet Service Provider</span>
            <span className="text-sm">{lastActivity?.isp || 'Unknown'}</span>
          </div>

          <div className="flex justify-between items-center p-3 bg-gray-50 rounded-lg">
            <span className="text-sm font-medium">Location</span>
            <span className="text-sm">{getLocation()}</span>
          </div>

          <div className="flex justify-between items-center p-3 bg-gray-50 rounded-lg">
            <span className="text-sm font-medium">Network Quality</span>
            <div className="flex items-center gap-2">
            </div>
          </div>

          <div className="flex justify-between items-center p-3 bg-gray-50 rounded-lg">
            <div className="flex items-center gap-1.5">
              <Download className="h-4 w-4 text-green-500" />
              <span className="text-sm font-medium">Download Speed</span>
            </div>
            <span className="text-sm">{lastActivity?.download || '0'} Mbps</span>
          </div>

          <div className="flex justify-between items-center p-3 bg-gray-50 rounded-lg">
            <div className="flex items-center gap-1.5">
              <Upload className="h-4 w-4 text-blue-500" />
              <span className="text-sm font-medium">Upload Speed</span>
            </div>
            <span className="text-sm">{lastActivity?.upload || '0'} Mbps</span>
          </div>

          <div className="flex justify-between items-center p-3 bg-gray-50 rounded-lg">
            <div className="flex items-center gap-1.5">
              <Clock className="h-4 w-4 text-indigo-500" />
              <span className="text-sm font-medium">Latency</span>
            </div>
            <span className="text-sm">{lastActivity?.latency || '0'} ms</span>
          </div>

          <div className="flex justify-between items-center p-3 bg-gray-50 rounded-lg">
            <div className="flex items-center gap-1.5">
              <Activity className="h-4 w-4 text-red-500" />
              <span className="text-sm font-medium">Packet Loss</span>
            </div>
            <span className="text-sm">{lastActivity?.packetLoss || '0'}</span>
          </div>

          <div className="flex justify-between items-center p-3 bg-gray-50 rounded-lg">
            <div className="flex items-center gap-1.5">
              <NetworkIcon className="h-4 w-4 text-amber-500" />
              <span className="text-sm font-medium">Jitter</span>
            </div>
            <span className="text-sm">{lastActivity?.jitter || '0'} ms</span>
          </div>

          <div className="flex justify-between items-center p-3 bg-gray-50 rounded-lg">
            <div className="flex items-center gap-1.5">
              <CalendarClock className="h-4 w-4 text-gray-500" />
              <span className="text-sm font-medium">Test Date</span>
            </div>
            <span className="text-sm">{lastActivity?.date}</span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default NetworkStats;
